import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { HiMiniBars3BottomRight } from "react-icons/hi2";
import { AiOutlineClose } from "react-icons/ai";
import { SlArrowDown } from "react-icons/sl";

import "./Header.css";
import logo from "../assets/logo.png";
import logowhite from "../assets/logowhite.png";

function Header() {
  const navigate = useNavigate();
  const location = useLocation(); // Gets the current route
  const [menu, setMenu] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const position = window.pageYOffset;
      setScrollPosition(position);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const headerStyle = {
    backgroundColor: scrollPosition > 0 ? "#fcfcfc" : "transparent",
    transition: "background-color 0.3s ease-in-out",
  };

  const checkActive = (path) => (location.pathname === path ? "active" : "");

  const handleMobileNav = (path) => {
    navigate(path);
    setMenu(false);
  };

  return (
    <div className="header" style={headerStyle}>
      <Link to="/">
        <img src={logo} alt="" className="header_logo" />
      </Link>
      <div>
        <ul className="header_nav">
          <li>
            <Link
              to="/story"
              className={`header_nav_list ${checkActive("/story")}`}
            >
              My Story
            </Link>
          </li>
          <li>
            <Link
              to="/engineering"
              className={`header_nav_list ${checkActive("/engineering")}`}
            >
              Engineering
            </Link>
          </li>
          <li>
            <Link
              to="/developer"
              className={`header_nav_list ${checkActive("/developer")}`}
            >
              Software
            </Link>
          </li>
          <li>
            <Link
              to="/design"
              className={`header_nav_list ${checkActive("/design")}`}
            >
              Design
            </Link>
          </li>
          <li>
            <Link
              to="/writer"
              className={`header_nav_list ${checkActive("/writer")}`}
            >
              Publications
            </Link>
          </li>
          <li>
            <Link
              to="/insight"
              className={`header_nav_list ${checkActive("/insight")}`}
            >
              Insight
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              className={`header_nav_list ${checkActive("/contact")}`}
            >
              Contact
            </Link>
          </li>
        </ul>
      </div>

      <HiMiniBars3BottomRight
        className="home_menu"
        onClick={() => {
          setMenu(true);
        }}
      />
      <div className={menu ? "home_sidebar_true" : "home_sidebar"}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Link to="/">
            <img src={logowhite} alt="" className="header_logo_2" />
          </Link>
          <AiOutlineClose
            className="home_sidebar_close"
            onClick={() => {
              setMenu(false);
            }}
          />
        </div>
        <ul className="home_sidebar_navbar">
          <li
            className={checkActive("/story")}
            onClick={() => handleMobileNav("/story")}
          >
            My story
          </li>
          <li
            className={checkActive("/engineering")}
            onClick={() => handleMobileNav("/engineering")}
          >
            Engineering
          </li>
          <li
            className={checkActive("/developer")}
            onClick={() => handleMobileNav("/developer")}
          >
            Software
          </li>
          <li
            className={checkActive("/design")}
            onClick={() => handleMobileNav("/design")}
          >
            Design
          </li>
          <li
            className={checkActive("/writer")}
            onClick={() => handleMobileNav("/writer")}
          >
            Publications
          </li>
          <li
            className={checkActive("/insight")}
            onClick={() => handleMobileNav("/insight")}
          >
            Insight
          </li>
          <li
            className={checkActive("/contact")}
            onClick={() => handleMobileNav("/contact")}
          >
            Contact
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Header;
